import { lazy, Suspense } from "react";
import type { MathTextProps } from "./eager";

const Eager = lazy(() => import("./eager"));

/**
 * Text with its LaTeX math rendered inline by KaTeX, for one-line contexts
 * like titles and clamped abstracts. Shows the raw text while KaTeX loads.
 */
export default function MathText({ children }: MathTextProps) {
  return (
    <Suspense fallback={children}>
      <Eager>{children}</Eager>
    </Suspense>
  );
}
